export default function initTabs() {
  const tabContainers = document.querySelectorAll(".tabs");
  if (!tabContainers.length) {
    return;
  }
  tabContainers.forEach(function (tabContainer) {
    const tabs = tabContainer.querySelectorAll("[data-tab]");
    const clickableTabs = tabContainer.classList.contains('tabs-clickable');
    const tabEvent = clickableTabs ? "click" : "mouseenter";

    if (!tabs || tabs.length <= 0) {
      return;
    }
    let activeTab = tabs[0].dataset.tab;
    function setActiveTab(tabId) {
      // hide previous tab content
      tabContainer
        .querySelector(`[data-tab=${activeTab}]`)
        .classList.remove("is-active");
      document.querySelector(`#tab-${activeTab}`).classList.add("hidden");

      // set new active tab
      activeTab = tabId;

      // show new tab content
      tabContainer
        .querySelector(`[data-tab=${activeTab}]`)
        .classList.add("is-active");
      document.querySelector(`#tab-${activeTab}`).classList.remove("hidden");
    }

    tabs.forEach((tab) => {
      tab.addEventListener(
        tabEvent,
        (e) => {
          setActiveTab(tab.dataset.tab);
        },
        false
      );
    });
  });
}
